import { TextLink } from '@snsw/react-component-library';
import { InPageAlert } from '@snsw/react-component-library';
import { HelpMessage } from '../../UserFeedback';
import { DownloadLink, ResponseValueType, SupportingDocument } from '../types';

const SupportingDocumentDownloadLink = ({ url, displayText }: DownloadLink) => (
  <div>
    <TextLink isExternal href={url}>
      {displayText}
    </TextLink>
  </div>
);

interface SupportingDocumentDownloadLinkProps<TValue extends ResponseValueType = boolean> {
  downloadLink?: SupportingDocument<TValue>['downloadLink'];
}

const SupportingDocumentDownloadLinks = <TValue extends ResponseValueType = boolean>({
  downloadLink,
}: SupportingDocumentDownloadLinkProps<TValue>) => {
  if (!Array.isArray(downloadLink)) {
    return Boolean(downloadLink) ? <SupportingDocumentDownloadLink {...downloadLink} /> : null;
  }

  if (downloadLink.length === 0) return null;

  return (
    <>
      {downloadLink.map((d) => (
        <SupportingDocumentDownloadLink key={d.displayText} {...d} />
      ))}
    </>
  );
};

export const SupportingDocuments = <TValue extends ResponseValueType = boolean>({
  value,
  documents,
}: {
  value: TValue[] | TValue;
  documents?: SupportingDocument<TValue>[];
}) => {
  if (!documents?.length) return null;

  return (
    <>
      {documents.map((d, index) => (
        <InPageAlert id={d.id} key={d.id ?? index} variant="info" title={d.title}>
          <HelpMessage>{typeof d.helpMessage === 'function' ? d.helpMessage(value) : d.helpMessage}</HelpMessage>
          <SupportingDocumentDownloadLinks downloadLink={d.downloadLink} />
        </InPageAlert>
      ))}
    </>
  );
};
